module.exports = __webpack_public_path__ + "img/2.0e5442b6.png";